module.exports = __webpack_public_path__ + "assets/BG_Landscape_1920x1080.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/ai-preview/BG_Landscape_1920x1080.jpg
// module id = 838
// module chunks = 0